// extracted by mini-css-extract-plugin
export default {"wrapper":"cookieBannerHeader_wrapper","showBackButton":"cookieBannerHeader_showBackButton","backButton":"cookieBannerHeader_backButton","header":"cookieBannerHeader_header"};